import * as React from "react";

const SvgIcnGoogleBusinessMessages = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.713 13.381v1.572c0 .695.497 1.29 1.144 1.29h6.958c.504-.001.803.005.983.014l1.54 1.846c.264.317.674.42 1.034.26.36-.16.596-.55.596-.986V8.062c0-.695-.497-1.29-1.144-1.29h-1.92v1.06h1.92c.111 0 .201.103.201.23v9.315l-1.738-2.084c-.075-.074-.171-.113-1.474-.11H7.857c-.111 0-.201-.104-.201-.23V13.38h-.943z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.603 14.124c-.363-.158-.603-.55-.603-.989V3.292C2 2.64 2.456 2 3.136 2H13.59c.68 0 1.136.64 1.136 1.292v6.941c0 .652-.456 1.292-1.137 1.292H6.426c-.467 0-.75.005-.923.013l-1.862 2.31c-.262.324-.674.434-1.038.276zm2.403-3.548c.072-.074.165-.113 1.421-.111h7.162c.107 0 .194-.104.194-.232V3.292c0-.128-.086-.232-.194-.232H3.136c-.107 0-.193.104-.193.232v9.843l2.063-2.56z"
            fill="currentColor"
        />
    </svg>
);

export default SvgIcnGoogleBusinessMessages;
